export default class RelationBase {
  get className(): string {
    return "RelationBase"; // no itx
  }

  activateAfterLoading() {
    // Override in subclass
    console.error("activateAfterLoading not implemented");
  }
}
